import { prop, pipe, filter, propEq, last, find, unless, isNil, path, ifElse, always, curryN, lte, defaultTo, split, append, map as map$1, findIndex, both, gte, __, merge, assoc, update, mergeAll, cond, is, identity, T, partialRight, apply, when, evolve, unapply, drop, zip, fromPairs, propSatisfies, equals, invoker } from 'ramda';
import { createReducer } from 'redux-create-reducer';
import { appendFlipped, ensureArray } from 'ramda-adjunct';
import { curry2 } from '@team-griffin/capra';
import { bindActionCreators as bindActionCreators$1 } from 'redux';
import { Stream, fromPromise, from, of, empty, join, switchLatest, concat } from 'most';
import { tap, filter as filter$1, map as map$2, recoverWith } from 'mostc';
import { selectArray } from 'redux-most';
import { createAction } from 'redux-actions';

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var curryCommand = function curryCommand(fn) {
  // @ts-ignore
  var curried = function curried(type, id, viewAggregate, state) {
    if (viewAggregate != null && _typeof(viewAggregate) === 'object') {
      return curried(type, id, void 0, viewAggregate);
    }

    if (state === void 0) {
      return function (state) {
        return curried(type, id, viewAggregate, state);
      };
    }

    if (type === void 0 && id === void 0) {
      return function (type, id) {
        return curried(type, id, viewAggregate, state);
      };
    }

    if (id === void 0) {
      return function (id) {
        return curried(type, id, viewAggregate, state);
      };
    }

    if (type === void 0) {
      return function (type) {
        return curried(type, id, viewAggregate, state);
      };
    }

    return fn(type, id, viewAggregate, state);
  };

  return curried;
}; // returns all commands


var getCommands = prop('commands'); // returns array of commands for a given id

var getCommandsById = function getCommandsById(id) {
  return pipe(getCommands, filter(propEq('id', id)));
}; // returns array of commands for a given type

var getCommandsByType = function getCommandsByType(type) {
  return pipe(getCommands, filter(propEq('type', type)));
}; // check the command against a given  view aggregate
// if the command is older than the view, discard it

var invalidateCommand = function invalidateCommand(view, state) {
  var pathToViewDate = pipe(defaultTo(''), split('.'), append('lastFetched'))(view);

  var compareDates = function compareDates(command) {
    var commandDate = command.updated || command.created;
    return curryN(2, ifElse(lte, always(null), always(command)))(commandDate);
  };

  return function (command) {
    return pipe(path(pathToViewDate), ifElse(isNil, always(command), compareDates(command)))(state);
  };
}; // returns the latest command for a given type


var getCommandByType = function getCommandByType(type) {
  return pipe(getCommandsByType(type), last);
}; // returns a single command for a given type/id combination
// for now getCommand just has a generic signature as it's a very
// tricky one to type
// eslint-disable-next-line max-len

var getCommand = curryCommand(function (type, id, view, state) {
  return pipe(getCommandsById(id), find(propEq('type', type)), unless(isNil, invalidateCommand(view, state)))(state);
}); // returns a single command's status for a given type/id combination
// @ts-ignore

var getCommandStatus = curryCommand(function (type, id, view, state) {
  return pipe(getCommand, prop('status'))(type, id, view, state);
});

var commands = /*#__PURE__*/Object.freeze({
  getCommands: getCommands,
  getCommandsById: getCommandsById,
  getCommandsByType: getCommandsByType,
  getCommandByType: getCommandByType,
  getCommand: getCommand,
  getCommandStatus: getCommandStatus
});

var idAndTypeMatch = function idAndTypeMatch(command) {
  return both(propEq('id', command.id), propEq('type', command.type));
};

var addCommand = function addCommand(command, list) {
  return pipe(assoc('created', new Date()), appendFlipped(list))(command);
};

var updateCommand = function updateCommand(update$1, command, list) {
  return pipe(merge(command), assoc('updated', new Date()), update(findIndex(idAndTypeMatch(command), list), __, // @ts-ignore - TS struggles with certain placeholder'd methods
  list))(update$1);
};

var writeCommand = function writeCommand(command, list) {
  return pipe(findIndex(idAndTypeMatch(command)), ifElse(gte(__, 0), function (i) {
    return updateCommand(command, list[i], list);
  }, function () {
    return addCommand(command, list);
  }))(list);
};

var initialState = [];

var createCommands = function createCommands(mapper) {
  var actions = map$1(function (fn) {
    return function (state, action) {
      var command = fn(action);
      return writeCommand(command, state);
    }; // @ts-ignore
  }, mapper);
  return createReducer(initialState, actions);
};

var combineCommands = function combineCommands(mappers) {
  return pipe(mergeAll, createCommands)(mappers);
};



var commands$1 = /*#__PURE__*/Object.freeze({
  selectors: commands,
  combineCommands: combineCommands,
  createCommands: createCommands
});

/* eslint-disable max-len */
var bindActionCreators = curry2(bindActionCreators$1);
var mergeProps = function mergeProps(stateProps, dispatchProps, ownProps) {
  return Object.assign({}, stateProps, ownProps, {
    actions: Object.assign({}, dispatchProps, ownProps.actions)
  });
};

/* eslint-enable */

function streamify(arg) {
  return cond([[is(Stream), identity], [is(Promise), fromPromise], [is(Array), from], [T, of]])(arg);
}

var createEpic = function createEpic( // eslint-disable-line max-len
userConfig) {
  var config = Object.assign({
    intercept: tap(always(null)),
    pending: function pending() {
      return empty();
    },
    filter: T,
    process: identity,
    transform: identity,
    onSuccess: function onSuccess() {
      return empty();
    },
    onFailure: function onFailure(err) {
      // eslint-disable-next-line no-console
      console.log(err);
      return empty();
    },
    join: false
  }, userConfig, {
    signal: [].concat(userConfig.signal)
  });
  var lift = config.join ? join : switchLatest;
  return function (actions$, store) {
    return pipe(selectArray(config.signal), filter$1(function (action) {
      return config.filter(action, store.getState(), actions$);
    }), config.intercept, map$2(function (action) {
      var state = store.getState();
      var pending = config.pending(action, state, actions$);
      var pending$ = streamify(pending); // @ts-ignore

      var process = config.process(action, state, actions$);
      var process$ = pipe(streamify, map$2(partialRight(config.transform, [action, state, actions$])))(process); // @ts-ignore

      var result$ = pipe(map$2( // @ts-ignore
      partialRight(config.onSuccess, [action, state, actions$])), map$2(streamify), lift, recoverWith(function (err) {
        return streamify(config.onFailure(err, action, state, actions$));
      }))(process$);
      return concat(pending$, result$);
    }), lift)(actions$);
  };
};

var directMap = function directMap(signal, message, payloadMapper) {
  var isActionCreator = always(is(Function, message));
  var isMapper = always(is(Function, payloadMapper)); // eslint-disable-next-line no-empty-function

  var noop = identity;
  return createEpic({
    signal: signal,
    onSuccess: ifElse(isActionCreator, // message is an action creator
    pipe(prop('payload'), ifElse(isMapper, pipe( // @ts-ignore - doesn't realise payloadMapper is a fn
    payloadMapper || noop, ensureArray, // @ts-ignore - doesn't realise message is a fn
    apply(message)), // @ts-ignore - doesn't realise message is a fn
    function (payload) {
      return (message || noop)(payload);
    })), // message is a type string
    pipe(assoc('type', message), when(isMapper, evolve({
      // @ts-ignore
      payload: payloadMapper || noop
    }))))
  });
};

var recoverWithMessage = function recoverWithMessage(actionCreator) {
  return recoverWith(function (err) {
    return of(actionCreator(err));
  });
};

/* eslint-disable max-len */

function payloadCreator(keys, offset) {
  return pipe(unapply(identity), drop(defaultTo(0, offset)), zip(keys), fromPairs);
}

var prefix = '@@ux/fabric/viewAggregate/M_';
var REQUESTED = "".concat(prefix, "REQUESTED");
var SUCCESS = "".concat(prefix, "SUCCESS");
var FAILURE = "".concat(prefix, "FAILURE");
var requested = createAction(REQUESTED, function (key, inputs) {
  return inputs;
}, function (key) {
  return {
    key: key
  };
});
var success = createAction(SUCCESS, function (key, data) {
  return data;
}, function (key) {
  return {
    key: key
  };
});
var failure = createAction(FAILURE, function (key, err) {
  return err;
}, function (key) {
  return {
    key: key
  };
});

var viewAggregate = /*#__PURE__*/Object.freeze({
  REQUESTED: REQUESTED,
  SUCCESS: SUCCESS,
  FAILURE: FAILURE,
  requested: requested,
  success: success,
  failure: failure
});

var assocWhen = function assocWhen(fn, key, value) {
  return function (obj) {
    return when(fn, assoc(key, value))(obj);
  };
};

var onlyOnAggregateKey = function onlyOnAggregateKey(key) {
  return function (fn) {
    return function (state, action) {
      return when(always(equals(key, action.meta.key)), function () {
        return fn(state, action);
      })(state);
    };
  };
};

var shouldUpdateFirstFetched = propSatisfies(isNil, 'firstFetched');
var initialState$1 = {
  ttl: null,
  inputs: {},
  firstFetched: null,
  lastFetched: null,
  fetching: false,
  data: null,
  error: null
};

var createViewAggregate = function createViewAggregate(key, ttl) {
  var _createReducer;

  return createReducer(Object.assign({}, initialState$1, {
    ttl: ttl
  }), (_createReducer = {}, _defineProperty(_createReducer, REQUESTED, onlyOnAggregateKey(key)(function (state, action) {
    return pipe(assoc('fetching', true), assoc('inputs', action.payload))(state);
  })), _defineProperty(_createReducer, SUCCESS, onlyOnAggregateKey(key)(function (state, action) {
    return pipe(assocWhen(shouldUpdateFirstFetched, 'firstFetched', new Date()), assoc('lastFetched', new Date()), assoc('fetching', false), assoc('data', action.payload), assoc('error', null))(state);
  })), _defineProperty(_createReducer, FAILURE, onlyOnAggregateKey(key)(function (state, action) {
    return pipe(assocWhen(shouldUpdateFirstFetched, 'firstFetched', new Date()), assoc('lastFetched', new Date()), assoc('fetching', false), assoc('data', null), assoc('error', action.payload))(state);
  })), _createReducer));
};

var createViewAggregateEpic = function createViewAggregateEpic(userConfig) {
  var config = Object.assign({
    filter: T,
    transform: identity,
    onSuccess: function onSuccess() {
      return empty();
    },
    onFailure: function onFailure() {
      return empty();
    }
  }, userConfig);
  var epicConfig = {
    signal: config.signal,
    filter: config.filter,
    pending: function pending(action) {
      return requested(config.key, action.payload);
    },
    process: config.fetch,
    transform: config.transform,
    onSuccess: function onSuccess(data, action, state, actions$) {
      return concat(of(success(config.key, data)), streamify(config.onSuccess(data, action, state, actions$)));
    },
    onFailure: function onFailure(err, action, state, actions$) {
      return concat(of(failure(config.key, err)), streamify(config.onFailure(err, action, state, actions$)));
    }
  };
  return createEpic(epicConfig);
};



var viewAggregate$1 = /*#__PURE__*/Object.freeze({
  messages: viewAggregate,
  createReducer: createViewAggregate,
  createEpic: createViewAggregateEpic
});

var after = function after(delay, value) {
  return new Promise(function (res) {
    setTimeout(function () {
      res(value);
    }, delay);
  });
};
var rejectAfter = function rejectAfter(delay, value) {
  return new Promise(function (res, rej) {
    setTimeout(function () {
      rej(value);
    }, delay);
  });
};
var map = invoker(1, 'then');
var mapRej = invoker(1, 'catch');

var promises = /*#__PURE__*/Object.freeze({
  after: after,
  rejectAfter: rejectAfter,
  map: map,
  mapRej: mapRej
});

export { bindActionCreators, commands$1 as commands, createEpic, directMap, mergeProps, payloadCreator, promises, recoverWithMessage, streamify, viewAggregate$1 as viewAggregate };
